/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentRadiationTechnique from './treatment-radiation-technique';
import TreatmentRadiationTechniqueDetail from './treatment-radiation-technique-detail';
import TreatmentRadiationTechniqueUpdate from './treatment-radiation-technique-update';
import TreatmentRadiationTechniqueDeleteDialog from './treatment-radiation-technique-delete-dialog';

const TreatmentRadiationTechniqueRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentRadiationTechnique />} />
    <Route path="new" element={<TreatmentRadiationTechniqueUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentRadiationTechniqueDetail />} />
      <Route path="edit" element={<TreatmentRadiationTechniqueUpdate />} />
      <Route path="delete" element={<TreatmentRadiationTechniqueDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentRadiationTechniqueRoutes;
